import { useMeEmailIsVerifiedApi } from '../../me/meApi';
import { useOApiAuthReady } from './useOApiAuthReady';
/**
 * Check the API is totally ready and whether this item cares about auth, user verification, etc.
 *
 * > WARNING - The following items are required by default:
 * > - `isVerificationRequired`
 * > - `isAuthRequired`
 * >
 * > you *must* explicitly declare your endpoint doesn't care about auth and email verification.
 *
 * returns true if you are cleared to make API request and false if any check fails.
 */
export const useOApiReady = ({ isVerificationRequired = true, isAuthRequired = true, }) => {
    const isAuthenticatedToApi = useOApiAuthReady(isAuthRequired);
    const isVerifiedApi = useMeEmailIsVerifiedApi();
    if (!isAuthenticatedToApi) {
        return false;
    }
    if (isVerificationRequired && !isVerifiedApi.data) {
        return false;
    }
    return true;
};
